import { Notificacao, PaginatedResponse } from '@aksape/types';
import { NotificacaoFiltersInput } from '@aksape/validators';
import { apiGet, apiPatch } from '~/shared/lib/api-client';

export const notificacoesApi = {
  list: (filters: Partial<NotificacaoFiltersInput>) =>
    apiGet<PaginatedResponse<Notificacao>>('/agenda/notificacoes', filters as Record<string, unknown>),

  countNaoLidas: () => apiGet<{ total: number }>('/agenda/notificacoes/nao-lidas/count'),

  marcarLida: (id: string) => apiPatch<Notificacao>(`/agenda/notificacoes/${id}/lida`),

  marcarTodasLidas: () => apiPatch<{ atualizadas: number }>('/agenda/notificacoes/marcar-todas-lidas'),
};
